export const LOADING_LABEL = 'loading';
